import { connect } from 'react-redux'

import { DateMenus } from '@components/groupOrders'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state: any) => {
  const { dateMenus, changedDateMenuMap, autoStagedMenus } = state.groupOrder
  const { lastLoggedInHq, locale } = state.user
  const currentHq = state.headquarter.headquarters.find(
    (h: any) => h.id === lastLoggedInHq,
  )
  const groupOrderMinimumItems = currentHq
    ? currentHq.groupOrderMinimumItems
    : null

  return {
    locale,
    headquarter: lastLoggedInHq,
    dateMenus,
    changedDateMenuMap,
    autoStagedMenus,
    groupOrderMinimumItems,
  }
}

const mapDispatchToProps = () => {
  const {
    pFilterUniversalMenu,
    pMergeItemWithMods,
    pRequestSettings,
    pResponseSettings,
    pResponseGroupOrderConcept,
    pResponseGroupOrderConcepts,
    pRequestSaveDateMenu,
    pResponseDateMenu,
  } = presenters.Api
  const { RestService, UIService, GroupOrdersService, SettingsService } =
    services
  const {
    DeleteDateMenus,
    GetGroupOrderBySettingsDate,
    GetGroupOrderConcept,
    GetGroupOrderUniversalConcept,
    SaveDateMenu,
    SearchGroupOrderConcepts,
    LoadMenuItemRatings,
    LoadSettings,
    ValidatePickupTimes,
    GetConceptEstPricePerPerson,
    FetchAndMergeMenuItemModifications,
    RetryOnTimeout,
  } = coordinators

  const {
    newDateMenu,
    setChangedDateMenuMap,
    updateDateMenus,
    setAutoStagedMenus,
    setDateMenuInDateMenus,
  } = GroupOrdersService
  const deleteDateMenus = DeleteDateMenus({
    RestService,
    UIService,
    HandleError,
  })
  const saveDateMenu = SaveDateMenu({
    RestService,
    UIService,
    HandleError,
    pRequestSaveDateMenu,
    pResponseDateMenu,
  })
  const getGroupOrderBySettingsDate = GetGroupOrderBySettingsDate({
    RestService,
  })
  const getGroupOrderConcept = GetGroupOrderConcept({
    RestService,
    pResponseGroupOrderConcept,
    HandleError,
  })
  const getGroupOrderUniversalConcept = GetGroupOrderUniversalConcept({
    RestService,
    pResponseGroupOrderConcept,
    pFilterUniversalMenu,
    HandleError,
  })
  const searchGroupOrderConcepts = SearchGroupOrderConcepts({
    RestService,
    pResponseGroupOrderConcepts,
    HandleError,
  })
  const fetchAndMergeMenuItemModifications = FetchAndMergeMenuItemModifications(
    {
      RestService,
      pMergeItemWithMods,
    },
  )
  const loadMenuItemRatings = LoadMenuItemRatings({ RestService })
  const loadMenuItemSettings = LoadSettings({
    RestService,
    SettingsService,
    pRequestSettings,
    pResponseSettings,
    RetryOnTimeout,
    HandleError,
  })('menuItems')
  const getConceptEstPricePerPerson = GetConceptEstPricePerPerson({
    RestService,
    HandleError,
  })
  const validateChefPickupTimes = ValidatePickupTimes({
    RestService,
    UIService,
    HandleError,
  })
  const {
    displayFailureMessage,
    displayWarningMessage,
    displaySuccessMessage,
  } = UIService.FlashMessage
  const { show: showConfirmationModal } = UIService.ConfirmationModal
  const showCustomModal = UIService.InfoModal.displayInfoModal

  return {
    deleteDateMenus,
    getGroupOrderBySettingsDate,
    fetchAndMergeMenuItemModifications,
    getGroupOrderConcept,
    getGroupOrderUniversalConcept,
    newDateMenu,
    setAutoStagedMenus,
    setChangedDateMenuMap,
    updateDateMenus,
    setDateMenuInDateMenus,
    saveDateMenu,
    showConfirmationModal,
    showCustomModal,
    searchGroupOrderConcepts,
    displayFailureMessage,
    loadMenuItemRatings,
    displaySuccessMessage,
    displayWarningMessage,
    validateChefPickupTimes,
    getConceptEstPricePerPerson,
    loadMenuItemSettings,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DateMenus)
